var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('rating-header',{attrs:{"ratio":_vm.logoSize}}),(_vm.getUserName)?_c('user-name'):_vm._e(),(!_vm.getUserName)?_c('user-name-create'):_vm._e(),(_vm.getUserName)?_c('rating-items'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }